import { ImageElement } from './image-model.js';
export const GifElement = ImageElement.named('Gif').props({
    type: 'gif',
    duration: 0,
    keepRatio: true,
});
